
export function serverError(
  // eslint-disable-next-line default-param-last
  state = {
    hasError: false,
    status: null,
    message: '',
    type: null
  },
  { type, error, meta }
) {
  if (type === "RESET_SERVER_ERROR") {
    // FIXME returning the default state actually doesn't return the "default" state
    // but returns the last state, so if it was an error it keeps that error even if reset
    // return state
    return { hasError: false, status: null, message: '', type: null }
  }

  switch (error?.type) {
    case "RecordNotFound":
    case "ValidationError":
      return { hasError: true, status: meta.status, message: error.message, type: error.type }

    // TODO these bottom three need to possibly obfuscate the message for 
    // security reasons, but allow some access to it for debugging
    case "AuthorizationError":
    case "AuthenticationError":
    case "InternalServerError":
      return { hasError: true, status: meta.status, message: error.message, type: error.type }

    default:
      return state
  }
}
